<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <p>
                                        <b>Customer:</b> {{order.registeredCompanyName}}
                                    </p>
                                    <p>
                                        <b>Order Date:</b> {{order.insertedOn}}
                                    </p>
                                    <p>
                                        <b>Order Type:</b> {{order.orderType}}
                                    </p>
                                    <p>
                                        <b>Order Status:</b> {{order.orderStatus}}
                                    </p>
                                    <p>
                                        <b>Customer Purchase Order Number:</b> {{order.customerPurchaseOrder}}
                                    </p>
                                    <p>
                                        <b>Transporter:</b> {{order.customerPurchaseOrder}}
                                    </p>
                                    <p>
                                        <b>Vehicle Make:</b> {{order.vehicleMake}}
                                    </p>
                                    <p>
                                        <b>Vehicle Model:</b> {{order.vehicleModel}}
                                    </p>
                                    <p>
                                        <b>Vehicle Registration:</b> {{order.vehicleRegistration}}
                                    </p>
                                    <p v-if="order.expectedUpliftmentDate !== null && order.expectedUpliftmentDate !== undefined">
                                        <b>Expected Upliftment:</b> {{order.expectedUpliftmentDate}}
                                    </p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                        <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="card border border-secondary pt-2">
                        <div class="card-body text-secondary">
                            <h5 class="card-title text-secondary">Items Ordered</h5>
                            <order-items-table
                                    :orderId="orderId"
                                    :orderTotal="orderGrandTotal"></order-items-table>

                        </div>
                    </div>
                    <br>
                    <div class="text-danger" v-if="reviewOrder.acceptOrder.hasError">
                        {{reviewOrder.acceptOrder.errorMessage}}
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="orderTypeRadios" id="acceptRejectOrderRadios1" :value="true" v-model="reviewOrder.acceptOrder.value"
                        >
                        <label class="form-check-label" for="acceptRejectOrderRadios1">
                            Accept Order
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="orderTypeRadios" id="acceptRejectOrderRadios2" :value="false" v-model="reviewOrder.acceptOrder.value">
                        <label class="form-check-label" for="acceptRejectOrderRadios2">
                            Reject Order
                        </label>
                    </div>
                    <br>
                    <div class="form-group">
                        <label>
                            SBO
                        </label>
                        <div class="text-danger" v-if="reviewOrder.sbo.hasError">
                            {{reviewOrder.sbo.errorMessage}}
                        </div>
                        <input type="text" class="form-control" v-model="reviewOrder.sbo.value">
                    </div>
                    <div class="form-group">
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile" @change="onReleaseLetterAttach" aria-describedby="fileHelp"
                                   accept="image/png, image/jpeg, .pdf">
                            <label class="custom-file-label text-truncate" for="customFile" v-if="reviewOrder.releaseLetter.value === null">
                                Choose Release Letter
                            </label>
                            <label class="custom-file-label text-truncate" for="customFile" v-if="reviewOrder.releaseLetter.value !== null">
                                {{reviewOrder.releaseLetter.value.name}}
                            </label>
                            <small id="fileHelp" class="form-text text-muted">Only images and PDFs are accepted. File attached cannot exceed 2MB</small>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="releaseSlipInput" @change="onReleaseSlipAttach" aria-describedby="fileHelpReleaseSlip"
                                   accept="image/png, image/jpeg, .pdf">
                            <label class="custom-file-label text-truncate" for="releaseSlipInput" v-if="reviewOrder.releaseSlip.value === null">
                                Choose Release Slip
                            </label>
                            <label class="custom-file-label text-truncate" for="releaseSlipInput" v-if="reviewOrder.releaseSlip.value !== null">
                                {{reviewOrder.releaseSlip.value.name}}
                            </label>
                            <small id="fileHelpReleaseSlip" class="form-text text-muted">Only images and PDFs are accepted. File attached cannot exceed 2MB</small>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <label for="reasonInput">
                            Comment
                        </label>
                        <textarea class="form-control" id="reasonInput" v-model="reviewOrder.comment.value" rows="4" cols="50"></textarea>
                    </div>
                    <button class="btn btn-primary" :disabled="loading" @click="acceptOrRejectExTankOrder">Save</button>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="'reviewOrderSuccessModal'"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="onSuccessModalOkClick">

    </success-modal>
    
    
</div>
